<template>
  <div>
    <h3>Important Dates:</h3>
    <el-table
        :data="tableData"
        stripe
        :show-header=false
        style="width: 100%">
      <el-table-column
          prop="name">
      </el-table-column>
      <el-table-column
          prop="deadline"
          label="Date">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [{
        deadline: '17 September, 2022',
        name: 'Submission deadline'
      }, {
        deadline: '05 October, 2022',
        name: 'Acceptance notification'
      }, {
        deadline: '15 October, 2022',
        name: 'Camera-ready of accepted papers'
      }, {
        deadline: '13 December, 2022',
        name: 'Conference and workshops'
      }]
    }
  }
}
</script>